var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-link',_vm._b({staticClass:"theme-styles"},'b-link',_vm.$attrs,false),[_vm._t("default",function(){return [_vm._v(" Message")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }